module.exports = __webpack_public_path__ + "static/media/auth-logo.2e15ad41.svg";